import { Component } from 'react'
import { FormattedMessage } from 'react-intl'
import ConvertMetersToFeets from '../helpers/ConvertMetersToFeets'
import PriceConverter from '../helpers/PriceConverter'
import { isLastMinuteBooking } from '../../utils'
import { get } from 'lodash'

export default class ResortPricingRowNoGuestsOrDate extends Component {
  handleClick = () => {
    this.props.triggerAvailabilityCalendar(true)
  }

  render() {
    const { room } = this.props
    return (
      <div className='resort-pricing-row'>
        <div className='resort-pricing__rooms'>
          <h4 className='room-name'>{ room.title }</h4>
          <div className='room-info'>
            <div className='room-image' style={{ backgroundImage: `url(${room.images[0].thumbnails.FeaturedDealsSmallDesktop})` }}>
              <div className='custom-paging'>1 / { room.images.length }</div>
            </div>
            <div className='room-info-wrapper'>
              <ul className='room-info-list'>
                <li>
                  <i className='font-icons people-icon' />
                  <FormattedMessage id='people_max'
                    values={{
                      maxOccupancy: room.maxOccupancy,
                    }}
                    defaultMessage='{ maxOccupancy, plural, one {# person} other {# people}} max' />
                </li>
                <li>
                  <i className='font-icons room-icon' />
                  <FormattedMessage id='bed_type'
                    values={{
                      bedTypeTitle: room.bedTypeTitle,
                    }}
                    defaultMessage='{ bedTypeTitle } bed' />
                </li>
                <li>
                  <i className='font-icons length-icon' />
                  <FormattedMessage id='room_size'
                    values={{
                      roomSize: <ConvertMetersToFeets data={room.size} currentUnits={this.props.areaFormat} />,
                    }}
                    defaultMessage='{ roomSize } room size' />
                </li>
                { room.minAge ? (
                  <li>
                    <i className='font-icons icon-warning' />
                    <FormattedMessage id='min_age'
                      values={{
                        minAge: room.minAge,
                      }}
                      defaultMessage='Min age of guests: {minAge}' />
                  </li>
                ) : ''}
              </ul>
              <a className='room-more-info' onClick={() => this.props.openRoomPopup(room)}>
                <FormattedMessage id='show_room_info' defaultMessage='Show room information' />
                <i className='font-icons right-arrow-icon' />
              </a>
            </div>
          </div>
        </div>
        <div className='resort-pricing__whats-included' />
        <div className='resort-pricing__meal-plan' />
        <div className='resort-pricing__price center-align'>
          <div className='pricing-wrapper'>
            <div className='price-per-guest-wrapper no-filters-selected'>
              <p className='price-per-guest__text mbn'>
                <FormattedMessage id='packages_from' defaultMessage='Packages from' />
              </p>
              <strong className='price-per-guest'>
                <PriceConverter amount={room.minPrice} currency={room.currency} />
              </strong>
              <p className='price-per-guest__text'>
                <FormattedMessage id='per_diver_for_7nights' defaultMessage='Per diver for 7 nights' />
              </p>
            </div>
            { this.props.noGuests ? (<div
              className='fake-input with-arrow'
              onClick={() => {
                setTimeout(function() {
                  document.querySelector('.rooms-and-guest-selector').click()
                })
              }}
              smooth-scroll='smooth-scroll'
              scroll-to='#resort-pricing'>
              <i className='font-icons people-icon' />
              <FormattedMessage id='select_guest_package' defaultMessage='Select guest package' />
            </div>) : (<div
              className='fake-input'
              onClick={() => {
                setTimeout(function() {
                  document.querySelector('.travel-datepicker').click()
                })
              }}
              smooth-scroll='smooth-scroll'
              scroll-to='#resort-pricing'>
              <i className='font-icons calendar-icon' />
              <FormattedMessage id='select_date' defaultMessage='Select date' />
            </div>) }
          </div>
          { !isLastMinuteBooking(get(this.props, 'date_0')) &&
          (<p className='benefit'>
            <i className='font-icons ok-icon-new' />
            <FormattedMessage id='48h_free_cancellation' defaultMessage='48h free cancellation period' />
          </p>
          )}
          <p className='price-explanation'><FormattedMessage id='prices_included_taxes' defaultMessage='Prices include taxes & service fees' /></p>
        </div>
      </div>
    )
  }
}
